import styled from 'styled-components';

export const AlertMessage = styled.div`
  margin-bottom: 15px;
  padding: 0 10px;
  min-height: 70px;
`;
